import { useEffect } from 'react';

/** Names the browser tab and history entry after the screen ("Einkaufsliste · Dishly"). */
export function useDocumentTitle(title: string | null | undefined) {
  useEffect(() => {
    document.title = title ? `${title} · Dishly` : 'Dishly';
  }, [title]);
}
